




























































import {Component, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsCallout from "@/design-system/components/Callout/JdsCallout.vue"
import JdsDatum from "@/design-system/components/Datum/JdsDatum.vue"

@Component({
    components: {JdsDatum, JdiPreview, JdiDocs, JdiContent}
})
export default class Datum extends Vue {

}
